// Dados de Cliente/Financeiro (aba CLIENTE, Editar Usuário) — GPS Drive
// Backend próprio (2026-08-27), primeiro backend real desta aba. Vinculado
// ao userId interno (UUID), mesmo id que GET/PUT /users/:userId/permissions
// já usa — ver gpsdrive-users.service.ts#resolveByTraccarId.
import { gpsDriveGet, gpsDrivePut } from "@/lib/api/gpsdrive-client";

// Pessoas autorizadas (2026-10-08) — também recebem por WhatsApp os avisos
// de Falha de Comunicação / Corte de Energia dos veículos do cliente.
export interface AuthorizedContact {
  name: string;
  phone: string;
  relationship: string | null;
  communicationFailure: boolean;
  powerCut: boolean;
}

export interface GpsDriveClientProfile {
  id: string;
  userId: string;
  cpfCnpj: string | null;
  companyName: string | null;
  contractName: string | null;
  rg: string | null;
  birthDate: string | null;
  postalCode: string | null;
  street: string | null;
  number: string | null;
  complement: string | null;
  neighborhood: string | null;
  city: string | null;
  state: string | null;
  mobilePhone: string | null;
  monthlyFee: string | null;
  landlinePhone: string | null;
  dueDay: number | null;
  billingEmail: string | null;
  incomeRevenue: string | null;
  supportPhone: string | null;
  notes: string | null;
  authorizedContacts?: AuthorizedContact[];
}

// authorizedContacts opcional: sem ele o backend mantém a lista atual
// (importação de usuários e outras telas nunca apagam).
export type UpdateGpsDriveClientProfileInput = Omit<GpsDriveClientProfile, "id" | "userId" | "authorizedContacts"> & {
  authorizedContacts?: AuthorizedContact[];
};

export const gpsDriveClientProfileService = {
  // null se a aba CLIENTE deste usuário nunca foi salva ainda.
  get: (userId: string) =>
    gpsDriveGet<GpsDriveClientProfile | null>(`/api/v1/users/${userId}/client-profile`),
  // Substitui o registro inteiro (mesmo contrato de PUT
  // /users/:userId/permissions) — nunca um PATCH parcial.
  replace: (userId: string, input: UpdateGpsDriveClientProfileInput) =>
    gpsDrivePut<GpsDriveClientProfile>(`/api/v1/users/${userId}/client-profile`, input),
};
